import { render, staticRenderFns } from "./CfoCoreIndicators.vue?vue&type=template&id=27f25f38&scoped=true"
import script from "./CfoCoreIndicators.vue?vue&type=script&lang=js"
export * from "./CfoCoreIndicators.vue?vue&type=script&lang=js"
import style0 from "./CfoCoreIndicators.vue?vue&type=style&index=0&id=27f25f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f25f38",
  null
  
)

export default component.exports